// import pictures
import freshmanFormal from '../images/our-story/freshman_year_formal.JPG';
import freshmanAddams from '../images/our-story/freshman_year_addams.JPEG';
import meelo from '../images/our-story/meelo_thanksgiving.jpg';
import house from '../images/our-story/bought_house.JPG';
import van from '../images/our-story/bought-van.jpg';
import italy from '../images/our-story/italy.JPG';
import engagement from '../images/our-story/engagement.jpg';
import rockies from '../images/our-story/rockies.JPG';
import mexico from '../images/our-story/mexico.jpg';

const ourStoryArray = [
  {
    key: 1,
    header: 'August 2016',
    subHeader: 'Vreth miadra',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: freshmanFormal,
    alt: 'Freshman Formal',
  },
  {
    key: 2,
    header: 'October/November 2016',
    subHeader: 'Kraldent frisma',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: freshmanAddams,
    alt: 'Addams Family Performance',
  },
  {
    key: 3,
    header: 'November 2020',
    subHeader: 'Milnor elva!',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: meelo,
    alt: 'Adopting Meelo',
  },
  {
    key: 4,
    header: 'March 2021',
    subHeader: 'Fetral morsig!',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: house,
    alt: 'Buying A Home',
  },
  {
    key: 5,
    header: 'May 2021',
    subHeader: 'Penvral yatros',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: mexico,
    alt: 'Mexico Vacation',
  },
  {
    key: 6,
    header: 'May 2022',
    subHeader: 'Rivtral mardex',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: rockies,
    alt: 'Rocky Mountain Hiking',
  },
  {
    key: 7,
    header: 'September 2023 - ??',
    subHeader: 'Grisvnal ferrak plindor',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: italy,
    alt: 'Italy Vacation',
  },
  {
    key: 8,
    header: 'April 2024',
    subHeader: 'Frelnak vantra!',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: van,
    alt: 'Bought a Van',
  },
  {
    key: 9,
    header: 'July 2024',
    subHeader: 'Engalithra!!!',
    text: 'Zethra lonis, kradthinal porevek dutria mos eltran kivun estal.',
    image: engagement,
    alt: 'Engaged',
  },
];

export default ourStoryArray;
